var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[(false)?_c('contract-upgrade-calculator',{attrs:{"preisKombiAbo":690,"vertragsEndDatum":"2024-12-06"}}):_vm._e(),_c('employee-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }